import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = ({ title, link, subTitle, title2, mainTitle }) => {
  const location = useLocation();
  return (
    <>
      <div
        id="header-wrapper"
        class="header-top-absolute"
        style={{
          marginBottom:
            location.pathname === "/about-us"
              ? 0
              : (location.pathname === "/wishlist" ||
                location.pathname === "/cart")
              ? 40
              : 0,
        }}
      >
        <section class="main-title-section-wrapper aligncenter">
          <div class="main-title-section-container">
            <div class="container">
              <div class="main-title-section">
                <h1>{mainTitle}</h1>
              </div>
              <div class="breadcrumb">
                <Link to={link}>{subTitle}</Link>
                <span class="breadcrumb-default-delimiter"></span>
                <span class="current">{title}</span>
                {title2 && (
                  <>
                    <span class="breadcrumb-default-delimiter"></span>
                    <span class="current">{title2}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div class="main-title-section-bg"></div>
        </section>
      </div>
    </>
  );
};

export default Breadcrumb;
